export default "__VITE_ASSET__5dbe2164__"